import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RolElement, UserElement, ListUsers } from '../models/user.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageService } from './language.service';

const API_URL = environment.API_URL


@Injectable({
  providedIn: 'root'
})

export class UserService {

  lstRoles: RolElement[] = [];
  lstUsers: ListUsers[] = [];

  constructor(private http: HttpClient, private translocoServie: TranslocoService, private langService: LanguageService) { }

  items: any = [];

  getAllUsers(company_id: number): Observable<UserElement[]> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/users`;
    return this.http.get<UserElement[]>(`${API_URL_USR}`);
  }

  getUserById(id: number, company_id: number): Observable<UserElement[]> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/users/${id}`;
    return this.http.get<UserElement[]>(`${API_URL_USR}`);
  }

  addUser(user: UserElement, company_id: number):Observable<any>  {
    const API_URL_USR = `${API_URL}/companies/${company_id}/users`;
    return this.http.post(`${API_URL_USR}`, user);
  }

  updateUser(id: number, user: UserElement, company_id: number):Observable<any>  {
    const API_URL_USR = `${API_URL}/companies/${company_id}/users/${id}`;
    return this.http.put(`${API_URL_USR}`, user);
  }

  deleteUser(id: number, company_id: number):Observable<any>  {
    const API_URL_USR = `${API_URL}/companies/${company_id}/users/${id}`;
    return this.http.delete(`${API_URL_USR}`);
  }

  getNotifiableUsers(companyId: number): Observable<any> {
    return this.http.get(`${API_URL}/companies/${companyId}/users`);
  }

  getRolesListByRole(role_id: number, company_id: number):RolElement[] {
    this.lstRoles=[];

    if(role_id == 1){
      //admin
      if(this.langService.getLang()=="es"){
        this.lstRoles = [
          {value: 1, viewValue: "Administrador"},
          {value: 2, viewValue: "Administrador de Empresa"},
          {value: 3, viewValue: "Usuario"}
        ];
      }
      else{
        this.lstRoles = [
          {value: 1, viewValue: "Administrator"},
          {value: 2, viewValue: "Company Administrator"},
          {value: 3, viewValue: "User"}
        ];
      }
    }else if(role_id == 2){
      //admin_comp
      if(this.langService.getLang()=="es"){
        this.lstRoles = [
          {value: 2, viewValue: "Administrador de Empresa"},
          {value: 3, viewValue: "Usuario"}
        ];
      }
      else{
        this.lstRoles = [
          {value: 2, viewValue: "Company Administrator"},
          {value: 3, viewValue: "User"}
        ];
      }
    }else{
      //user
      if(this.langService.getLang()=="es"){
        this.lstRoles = [
          {value: 3, viewValue: "Usuario"}
        ];
      }
      else{
        this.lstRoles = [
          {value: 3, viewValue: "User"}
        ];
      }
    }
    return this.lstRoles;
  }

  getUsersList(company_id: number):ListUsers[] {
    this.lstUsers=[];

    const req = this.getAllUsers(company_id);
    req.subscribe({
      next: (res) => {
        this.items = res;
        if(this.items.data != null){
          this.lstUsers.push( {value: undefined, viewValue: ''} );
          for (let itm of this.items.data ){
            this.lstUsers.push( {value: itm.id, viewValue: (itm.first_name + ' ' + itm.last_name)} );
          }
        }
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });

    return this.lstUsers;
  }
}
